<div class="az-selector" [class.az-selector--disabled]="disabled">
  @if (label) {
    <label class="az-selector__label">{{ label }}</label>
  }

  <div
    class="az-selector__control"
    (click)="toggleDropdown()"
    [class.az-selector__control--disabled]="disabled"
  >
    <span class="az-selector__selected">{{ selectedValue || 'Select an option' }}</span>
    <div class="az-selector__arrow-container">
      <span class="material-symbols-outlined az-selector__arrow" aria-hidden="true">
        {{ isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
      </span>
    </div>
  </div>

  @if (isOpen) {
    <div class="az-selector__dropdown">
      @for (option of options; track option) {
        <div
          class="az-selector__option"
          (click)="selectOption(option)"
          [class.az-selector__option--selected]="option === selectedValue"
        >
          {{ option }}
        </div>
      }
    </div>
  }
</div>
